<script>
import Layout from '@/Shared/Layout'
import Multiselect from '@/multiselect/src/Multiselect'

export default {
  layout: Layout,
  components: { Multiselect },
  data() {
    return {
      selected: null,
      options: ['Batman', 'Robin', 'Joker'],
    }
  },
}
</script>

<script setup>
import { Head, useForm } from '@inertiajs/inertia-vue3'
import { onMounted, onUnmounted, reactive } from 'vue'
import stripslashes from '@/Shared/helper.js'
import TextInput from '@/Shared/Form/TextInput'
import SelectInput from '@/Shared/Form/SelectInput'
import TextareaInput from '@/Shared/Form/TextareaInput'
import Icon from '@/Shared/Icons/Icon'
import Modal from '@/Shared/Modal/ModalContactConfirm'
import TextFor from '@/Shared/Icons/TextFor'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  slug: String,
  pref: Object,
})

const modal = reactive({ open: false })

const openModal = () => {
  form.relatedBrand = formAlt.relatedBrand.toString()
  usePref(props.pref)
  // useStore().updateModal({ id: id, category: category })
  modal.open = true
}

const subjects = {
  new: '新規のお取引に関しまして',
  support: 'お取引中の案件について',
  exhibition: '展示会への参加依頼',
}
const volumeValue = ['100万円以内', '500万円以内', '1,000万円以内', '3,000万円以内', 'それ以上']
const formData = {
  new: {
    subject: subjects[props.slug],
    contactName: '',
    contactBusinessName: '',
    contactBusinessUrl: '',
    contactEmail1: '',
    relatedBrand: null,
    volume: null,
    contactMessage: '',
  },
  support: {
    subject: subjects[props.slug],
    contactName: '',
    contactBusinessName: '',
    contactEmail1: '',
    relatedBrand: null,
    contactMessage: '',
  },
  exhibition: {
    subject: subjects[props.slug],
    contactName: '',
    contactBusinessName: '',
    contactEmail1: '',
    relatedBrand: null,
    contactEvent: null,
    contactMessage: '',
  },
}
const form = useForm('form', formData[props.slug])
const formAlt = reactive({
  relatedBrand: [],
})

const checkEmail = () => {
  if (form.contactEmail1 == '') {
    form.errors.contactEmail1 = 'メールは必須です'
  }
  if (form.contactName == '') {
    form.errors.contactName = '名前は必須です'
  }

  if (form.contactMessage == '') {
    form.errors.contactMessage = 'メッセージは必須です'
  }

  var el = document.getElementsByClassName('form-name')
  el[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
}
// const confirmform = () => {
//   form.post('/inquiry/confirm', { preserveScroll: true })
// }
const submitform = () => {
  form.post('/inquiry/submit')
}
const onUserAction = () => {
  form.errors.contactName = null
  form.errors.contactEmail1 = null
  form.errors.contactMessage = null
}
const brandLoop = () => {
  let r = {}
  props.pref.brands.forEach((ea) => {
    r[ea.brandSlug] = stripslashes(ea.brandName)
  })
  return r
}
const checkForm = () => {
  const r = form.contactEmail1 != '' && form.contactName != '' && form.contactMessage != '' ? true : false
  return r
}
function onChange(newval) {
  // console.log( 'newval' )
  form.relatedBrand = newval.toString()
}
onMounted(() => {
  if (typeof window !== 'undefined') {
    document.addEventListener('keypress', () => {
      onUserAction()
    })
  }
  brandLoop()
})
onUnmounted(() => {
  if (typeof window !== 'undefined') {
    document.removeEventListener('keypress', onUserAction)
  }
})
</script>

<template>
  <div>
    <Head title="お問い合わせ" />

    <div class="contact bg-afgray">
      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] lg:px-0 max-w-[600px] 2xl:max-w-[650px] pb-[60px] sm:pb-[80px]">
        <h2 class="page-title !text-left !pt-[0.8em] sm:!pt-[1em] !pb-[0.4em]">
          <TextFor />
          DEALERS
          <small>{{ form.subject }}</small>
        </h2>

        <div class="mx-auto text-[110%] text-left leading-[2] [&>p]:mb-[10px]">
          <template v-if="props.slug === 'new'">
            <p>この度は弊社のブランドに興味をもっていただきありがとうございます。</p>
            <p>弊社では日本国内に実店舗があり、且つ営業中の卸先様のみお取引をさせていただいております。<br class="hidden lg:block" />オンラインショップ店舗のみの場合は原則として、お取引ができません。</p>
            <p>また、ご希望に沿えない場合もございますので、予めご了承の上、下のフォームへに必要な情報を入力し送信ください。<br class="hidden sm:block" />通常2〜5営業日以内に担当の営業から回答致します。</p>
          </template>
          <template v-if="props.slug === 'support'">
            <p>すでにお取引のある様で卸先様で、オーダーした製品についてのお問い合わせは、<br class="hidden lg:block" />以下のフォームに必要な情報を入力して送信ください。担当のものが対応いたします。</p>
          </template>
          <template v-if="props.slug === 'exhibition'">
            <p>次回受注会・展示会についての質問や、参加希望も、フォームに必要な情報を入力し、<br class="hidden lg:block" />「展示会の参加希望を送信」ボタンをクリックして送信ください。</p>
          </template>
        </div>

        <form class="mx-auto my-[35px] sm:my-[50px]">
          <ul class="[&>li]:mb-[20px]">
            <li>
              <text-input v-model="form.contactName" :error="form.errors.contactName" class="form-name" type="text" autofocus autocapitalize="off" placeholder="お名前" />
            </li>
            <li>
              <text-input v-model="form.contactBusinessName" :error="form.errors.contactBusinessName" type="text" autocapitalize="off" placeholder="御社名・店舗名" />
            </li>
            <li>
              <text-input v-model="form.contactBusinessUrl" :error="form.errors.contactBusinessUrl" type="text" autocapitalize="off" placeholder="会社概要等のホームページURL" />
            </li>
            <li>
              <text-input v-model="form.contactEmail1" :error="form.errors.contactEmail1" class="email-1 error" type="email" autocapitalize="off" placeholder="メールアドレスを入力" />
            </li>
            <li>
              <input v-model="formAlt.relatedBrand" type="hidden" name="relatedBrand" />
              <Multiselect v-model="formAlt.relatedBrand" mode="tags" :options="brandLoop()" placeholder="興味のある・取引したいブランド" @update:model-value="onChange" />
            </li>

            <li v-if="props.slug == 'new'">
              <select-input v-model="form.volume">
                <option :value="null">年間希望取引額</option>
                <option v-for="v in volumeValue" :key="v" :value="v" v-html="v" />
              </select-input>
            </li>

            <li>
              <TextareaInput v-model="form.contactMessage" :error="form.errors.contactMessage" class="mt-10 resize" label="メッセージ" autocapitalize="off" :rows="6" />
            </li>
          </ul>

          <div class="mt-[40px]">
            <template v-if="checkForm()">
              <button type="button" @click.prevent="openModal()">送信する<Icon type="arrow" /></button>
            </template>
            <template v-else>
              <button type="button" @click="checkEmail()">送信する<Icon type="arrow" /></button>
            </template>
            <!-- <button type="button" @click.prevent="openModal(0, 'form')">form</button> -->
          </div>
        </form>

        <teleport to="#app">
          <transition name="fade">
            <Modal v-if="modal.open" category="form" :func="submitform" :params="form" :pref="props.pref" class="modal" @close="modal.open = false" />
          </transition>
        </teleport>
      </div>
    </div>
  </div>
</template>
